<template>
  <div class="video-card-wrapper">
    <div class="video-card">
      <iframe
        :src="`${
          video.url
        }?rel=0&modestbranding=1&iv_load_policy=3&controls=1&autoplay=${
          this.autoplay ? 1 : 0
        }&mute=${video.autoplay ? 1 : 0}`"
        :title="video.title"
        frameborder="0"
        allow="fullscreen; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
        webkitallowfullscreen
        mozallowfullscreen
      ></iframe>
    </div>
    <h3 class="video-title">{{ video.title }}</h3>
  </div>
</template>

<script>
export default {
  name: 'VideoCard',
  props: {
    video: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    autoplay: {
      type: Boolean,
    },
  },
};
</script>

<style scoped>
.video-card-wrapper {
  background: #1a1a1a;
  border-radius: 12px;
  padding: 1rem;
  cursor: pointer;
  transition: transform 0.2s ease;
  color: #eee;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.9);
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
}

.video-card-wrapper:hover {
  transform: scale(1.02);
  box-shadow: 0 0 10px #2c3e50;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.video-card {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
}
.video-card iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
}

.video-title {
  font-size: 1.3rem;
  margin: 0.8rem 0 0 0;
  color: #909078;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
